/* DivineDigits Studio — shared behaviour: header, drawer, reveal, cart, quick add, forms, toast */
(function () {
  'use strict';
  const doc = document, body = doc.body;
  const LANG = body.dataset.lang || 'en', ROOT = body.dataset.root || '';
  const SHOPIFY = '';
  /* Shopify serves the French storefront under /fr. Handing a French shopper
     the bare /cart drops them into the English checkout, which is where the
     bag stops being bilingual. On the theme SHOPIFY is '' so this resolves to
     /fr/cart; on the static site it resolves to the full URL. */
  const SHOP = SHOPIFY + (LANG === 'fr' ? '/fr' : '');
  const $ = (s, c) => (c || doc).querySelector(s), $$ = (s, c) => Array.from((c || doc).querySelectorAll(s));
  const T = {
    en: { added: 'Added to your bag', removed: 'Removed', size: 'Size', shape: 'Shape', qty: 'Qty', remove: 'Remove', copied: 'Link copied', unavailable: 'This combination is unavailable', choose: 'Choose options', added_btn: 'Added ✓', addShort: 'Add', inBag: 'In your bag', mto: 'Made to order · about 14 business days' },
    fr: { added: 'Ajouté à votre panier', removed: 'Retiré', size: 'Taille', shape: 'Forme', qty: 'Qté', remove: 'Retirer', copied: 'Lien copié', unavailable: 'Cette combinaison est indisponible', choose: 'Choisir les options', added_btn: 'Ajouté ✓', addShort: 'Ajouter', inBag: 'Dans le panier', mto: 'Sur commande · environ 14 jours ouvrables' }
  }[LANG];
  const fmt = n => { const s = Number.isInteger(n) ? String(n) : n.toFixed(2); return LANG === 'fr' ? s.replace('.', ',') + ' $' : '$' + s; };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  /* Prefix a site-relative path with the locale root — but only once.
     Shopify's own endpoints (search/suggest.json, recommendations) answer
     the French storefront with URLs that ALREADY carry /fr, so adding ROOT
     again gave /fr/fr/products/x and a 404 straight off the search drawer. */
  const U = u => {
    if (!u || /^(https?:)?\/\//.test(u)) return u;
    if (ROOT && (u === ROOT || u.slice(0, ROOT.length + 1) === ROOT + '/')) return u;
    return ROOT + u;
  };
  const prelaunchText = JSON.parse(document.getElementById('dd-prelaunch-strings').textContent);
  const prelaunch = window.DDPrelaunch;
  const productSeed = document.getElementById('product-data');
  if (productSeed) { try { prelaunch.seed(JSON.parse(productSeed.textContent)); } catch (error) {} }
  window.DD = window.DD || {}; DD.prelaunchText = prelaunchText; DD.fmt = fmt; DD.esc = esc; DD.lang = LANG; DD.root = ROOT; DD.T = T;

  /* ---- header: transparent over hero, hide on scroll down ---- */
  const header = $('#header');
  let lastY = window.scrollY, ticking = false;
  function onScroll() {
    const y = window.scrollY;
    if (body.classList.contains('page-home')) header.classList.toggle('is-top', y < 40);
    header.classList.toggle('is-scrolled', y > 24);
    const mb = $('[data-mobilebar]'); if (mb) { mb.hidden = false; mb.classList.toggle('is-on', y > 700 && y < doc.body.scrollHeight - window.innerHeight - 500); }
    lastY = y; ticking = false;
  }
  if (body.classList.contains('page-home')) header.classList.add('is-top');
  window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
  onScroll();
  // mark current nav item
  const here = location.pathname.split('/').pop() || 'index.html';
  $$('.nav__item > a').forEach(a => { if ((a.getAttribute('href') || '').split('/').pop().split('?')[0] === here) a.setAttribute('aria-current', 'page'); });

  /* panels: if a transition never completes (throttled tab), force the end state */
  const settle = (panel, open, end) => setTimeout(() => { if (!panel) return; if (open) { panel.style.transform = 'none'; panel.style.opacity = '1'; } else { panel.style.transform = ''; panel.style.opacity = ''; } }, end || 700);
  /* ---- drawer ---- */
  const drawer = $('#drawer');
  function setDrawer(open) { drawer.setAttribute('aria-hidden', open ? 'false' : 'true'); $('[data-drawer-open]').setAttribute('aria-expanded', open ? 'true' : 'false'); body.style.overflow = open ? 'hidden' : ''; settle($('.drawer__panel'), open); }
  $$('[data-drawer-open]').forEach(b => b.addEventListener('click', () => setDrawer(true)));
  $$('[data-drawer-close]').forEach(b => b.addEventListener('click', () => setDrawer(false)));

  /* ---- reveal on scroll (IntersectionObserver + safety net) ---- */
  const rv = $$('.rv');
  rv.forEach((el, i) => { if (el.style && typeof el.style.getPropertyValue === 'function' && !el.style.getPropertyValue('--i')) { const sib = Array.from(el.parentElement.children).filter(c => c.classList.contains('rv')); el.style.setProperty('--i', sib.indexOf(el) % 8); } });
  const show = el => { el.classList.add('is-in'); };
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }), { rootMargin: '0px 0px 12% 0px', threshold: 0 });
    rv.forEach(el => io.observe(el));
  } else rv.forEach(show);
  const vh = () => Math.max(window.innerHeight || 0, doc.documentElement.clientHeight || 0, 700);
  const sweep = () => rv.forEach(el => { if (!el.classList.contains('is-in')) { const r = el.getBoundingClientRect(); if (r.top < vh() * 1.15 && r.bottom > -50) show(el); } });
  window.addEventListener('scroll', sweep, { passive: true }); window.addEventListener('load', sweep); setInterval(sweep, 900);
  // if a transition never runs (throttled tab), force final state after 1.6s of being marked
  new MutationObserver(ms => ms.forEach(m => { const el = m.target; if (el.classList.contains('is-in')) setTimeout(() => { if (getComputedStyle(el).opacity !== '1') { el.style.opacity = '1'; el.style.transform = 'none'; } }, 1600); })).observe(doc.documentElement, { attributes: true, subtree: true, attributeFilter: ['class'] });

  /* ---- toast ---- */
  const toastEl = $('[data-toast]'); let toastT;
  DD.toast = (msg) => { toastEl.innerHTML = `<svg class="ico" viewBox="0 0 24 24"><use href="#i-check"/></svg><span>${esc(msg)}</span>`; toastEl.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2600); };

  /* ---- variant helpers (shared with product.js) ---- */
  DD.optionLabel = (opt, key) => { const v = opt.values.find(x => x.key === key); return v ? (typeof v.label === 'string' ? v.label : v.label[LANG]) : key; };
  DD.findVariant = (p, sel) => p.variants.find(v => v.o.every((k, i) => !p.options[i] || k === sel[i]));
  DD.available = (p, sel, pos, key) => p.variants.some(v => (p.comingSoon || v.available) && v.o.every((k, i) => i === pos ? k === key : (!sel[i] || k === sel[i])));
  /* On the shelf right now. A made-to-order variant is orderable but NOT in
     stock, so it still gets crossed out — the cross says "we have to make it",
     not "you cannot have it". */
  DD.inStock = (p, sel, pos, key) => p.variants.some(v => (p.comingSoon || (v.available && !v.mto)) && v.o.every((k, i) => i === pos ? k === key : (!sel[i] || k === sel[i])));
  DD.lineFor = (p, sel, qty) => {
    const v = DD.findVariant(p, sel); if (!v) return null;
    const opts = p.options.map((o, i) => DD.optionLabel(o, sel[i])).filter(Boolean).join(' / ');
    return { id: v.id, qty, handle: p.h || p.handle, title: typeof p.t === 'object' ? p.t[LANG] : (p.title || p.t), opts, price: v.price, img: p.img, url: typeof p.url === 'object' ? p.url[LANG] : p.url, ...(p.comingSoon ? {comingSoon: true} : v.mto ? {mto: true} : {}) };
  };

  /* ---- cart ---- */
  const wardrobeData = $('#nw-accessory-data');
  if (wardrobeData) {
    try {
      const wardrobe = JSON.parse(wardrobeData.textContent);
      if (wardrobe.variants && wardrobe.variants.some(v => v.available)) {
        window.DD_PRODUCTS = (window.DD_PRODUCTS || []).filter(p => p.h !== wardrobe.h);
        window.DD_PRODUCTS.unshift(wardrobe);
      }
    } catch (error) { console.warn('Storage case recommendation unavailable.'); }
  }
  const KEY = 'dd_cart_v1';
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const save = items => { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { } };
  let cart = load();
  const cartEl = $('#cart');
  function count() { return cart.reduce((n, i) => n + i.qty, 0); }
  function renderCart() {
    const n = count();
    $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = n === 0; });
    $$('[data-cart-count-inline]').forEach(el => el.textContent = n ? `(${n})` : '');
    cartEl.classList.toggle('is-empty', n === 0);
    const state = prelaunch.summary(cart);
    const list = $('[data-cart-items]');
    let previousGroup = '';
    const entries = state.entries.slice().sort((a,b) => (a.status === 'ready' ? 0 : 1) - (b.status === 'ready' ? 0 : 1));
    list.innerHTML = entries.map(({item:i, index:idx, status}) => {
      const group = status === 'ready' ? 'ready_group' : 'saved_group';
      const heading = state.comingSoon && state.ready.length && group !== previousGroup ? `<p class="cart__group-label">${esc(prelaunchText.cart[group])}</p>` : '';
      previousGroup = group;
      const statusText = status === 'coming-soon' ? `<div class="item__prelaunch">${esc(prelaunchText.cart.saved)}</div>` : status === 'unavailable' ? `<div class="item__blocked">${esc(prelaunchText.cart.unavailable)}</div>` : status === 'checking' ? `<div class="item__blocked">${esc(prelaunchText.cart.checking)}</div>` : i.mto ? `<div class="item__mto">${esc(T.mto)}</div>` : '';
      return `${heading}<div class="item" data-idx="${idx}">
      ${i.img ? `<a href="${U(i.url)}"><img src="${U(i.img)}" alt=""></a>` : `<div class="item__ph"><svg class="nail" viewBox="0 0 60 100"><use href="#shape-almond"/></svg></div>`}
      <div><div class="item__title"><a href="${U(i.url)}">${esc(i.title)}</a></div><div class="item__opts">${esc(i.opts)}</div>${statusText}
        <div class="qty qty--sm"><button type="button" data-dec aria-label="−">−</button><input type="number" value="${i.qty}" min="1" max="10" aria-label="${T.qty}"><button type="button" data-inc aria-label="+">+</button></div></div>
      <div><div class="item__price">${fmt(i.price * i.qty)}</div><button type="button" class="item__remove" data-remove>${T.remove}</button></div></div>`; }).join('');
    renderAddons();
    $$('[data-nw-add]').forEach(button => {
      const p = (window.DD_PRODUCTS || []).find(item => item.h === button.dataset.nwAdd);
      const variant = p && p.variants.find(v => v.available);
      const inBag = variant && cart.some(item => String(item.id) === String(variant.id));
      button.disabled = !variant || !!inBag;
      button.textContent = inBag ? button.dataset.inBagLabel : button.dataset.addLabel;
    });
    $('[data-cart-subtotal]').textContent = fmt(state.subtotal);
    const hasSaved = state.comingSoon || state.unavailable;
    $('[data-cart-subtotal-label]').textContent = hasSaved ? prelaunchText.cart.subtotal : (LANG === 'fr' ? 'Sous-total' : 'Subtotal');
    $('[data-cart-subtotal-row]').hidden = !state.ready.length;
    $('[data-cart-payment-note]').hidden = !state.ready.length;
    const note = $('[data-cart-prelaunch]');
    note.hidden = !hasSaved && !state.checking;
    note.textContent = state.checking ? (state.failed ? prelaunchText.cart.retry_notice : prelaunchText.cart.checking_notice) : state.comingSoon ? prelaunchText.cart.notice : prelaunchText.cart.unavailable_notice;
    $('[data-cart-retry]').hidden = !state.failed;
    const co = $('[data-cart-checkout]');
    const blocked = state.checking || !state.ready.length;
    co.setAttribute('aria-disabled', String(blocked));
    $('[data-cart-checkout-label]').textContent = state.checking ? prelaunchText.cart.checking : !state.ready.length ? (state.comingSoon ? prelaunchText.cart.blocked : prelaunchText.cart.unavailable) : hasSaved ? prelaunchText.cart.checkout : prelaunchText.cart.standard;
    if (blocked) { co.removeAttribute('href'); co.setAttribute('tabindex','-1'); }
    else {
      co.removeAttribute('tabindex');
      const attrs = []; let configured = 0;
      state.ready.forEach(i => {
        if (!i.attrs) return;
        configured += 1;
        Object.keys(i.attrs).forEach(k => {
          const key = configured > 1 ? `${k} (${configured})` : k;
          attrs.push(`attributes[${encodeURIComponent(key)}]=${encodeURIComponent(i.attrs[k])}`);
        });
      });
      co.href = `${SHOP}/cart/${state.ready.map(i => `${i.id}:${i.qty}`).join(',')}` + (attrs.length ? '?' + attrs.join('&') : '');
    }
  }
  /* Accessories offered right in the bag — tabs, glue, remover, whatever is
     typed 'accessory' in the catalogue — so nobody checks out without them. */
  function renderAddons() {
    const box = $('[data-cart-addons]'), list = $('[data-addons-list]'); if (!box || !list) return;
    const P = window.DD_PRODUCTS || [];
    const acc = (window.DD_ACCESSORIES || P.filter(p => p.type === 'accessory')).filter(p => p.variants.some(v => v.available));
    box.hidden = !acc.length || !cart.length;
    if (box.hidden) { list.innerHTML = ''; return; }
    const inBag = id => cart.some(i => i.id === id);
    const short = k => /sheets|feuilles/i.test(k) ? String(k).split(/[\s（(]/)[0] : String(k);
    list.innerHTML = acc.map(p => {
      const title = typeof p.t === 'object' ? p.t[LANG] : p.t;
      const btns = p.options.length
        ? p.options[0].values.map(v => { const vr = DD.findVariant(p, [v.key]); if (!vr || !vr.available) return ''; const on = inBag(vr.id); return `<button type="button" class="addon__btn${on ? ' is-in' : ''}" data-addon="${esc(p.h)}" data-sel="${esc(v.key)}" ${on ? 'disabled' : ''} title="${esc(DD.optionLabel(p.options[0], v.key))}">${esc(short(v.key))}</button>`; }).join('')
        : (() => { const on = inBag(p.variants[0].id); return `<button type="button" class="addon__btn${on ? ' is-in' : ''}" data-addon="${esc(p.h)}" ${on ? 'disabled' : ''}>${on ? esc(T.inBag) : esc(T.addShort)}</button>`; })();
      return `<div class="addon">${p.img ? `<img src="${U(p.img)}" alt="" loading="lazy">` : '<span class="addon__ph"></span>'}<div><div class="addon__t"><a href="${esc(U(p.url))}">${esc(title)}</a></div><div class="addon__p">${fmt(p.price)}</div></div><div class="addon__btns">${btns}</div></div>`;
    }).join('');
  }
  $$('[data-nw-add]').forEach(button => button.addEventListener('click', () => {
    const p = (window.DD_PRODUCTS || []).find(item => item.h === button.dataset.nwAdd);
    const variant = p && p.variants.find(v => v.available);
    if (!variant || cart.some(item => String(item.id) === String(variant.id))) return;
    const line = DD.lineFor(p, [], 1);
    if (line) DD.add(line);
  }));
  $('[data-addons-list]') && $('[data-addons-list]').addEventListener('click', async e => {
    const b = e.target.closest('[data-addon]'); if (!b) return;
    const p = (window.DD_ACCESSORIES || window.DD_PRODUCTS || []).find(x => x.h === b.dataset.addon); if (!p) return;
    const v = DD.findVariant(p, b.dataset.sel ? [b.dataset.sel] : []); if (!v) return;
    if (DD.addAccessory) {
      const old = b.textContent; b.disabled = true; b.textContent = '…';
      try { await DD.addAccessory(p.h, v.id, 1); }
      catch (error) { b.disabled = false; b.textContent = old; DD.toast(error.message); }
    } else { DD.add(DD.lineFor(p, b.dataset.sel ? [b.dataset.sel] : [], 1)); }
  });
  function setCart(open) { cartEl.setAttribute('aria-hidden', open ? 'false' : 'true'); body.style.overflow = open ? 'hidden' : ''; if (open) { renderCart(); refreshCart(true); } settle($('.cart__panel'), open); }
  DD.add = (line) => {
    const sig = i => i.id + '|' + (i.attrs ? JSON.stringify(i.attrs) : '');
    const ex = cart.find(i => sig(i) === sig(line));
    if (ex) { const qty = Math.min(10, ex.qty + line.qty); Object.assign(ex, line, {qty}); } else cart.push(line);
    save(cart); renderCart(); refreshCart(); DD.toast(line.comingSoon ? prelaunchText.cart.toast : T.added); setTimeout(() => setCart(true), 350);
  };
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', () => setCart(true)));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', () => setCart(false)));
  $('[data-cart-items]').addEventListener('click', e => {
    const row = e.target.closest('.item'); if (!row) return; const idx = +row.dataset.idx;
    if (e.target.closest('[data-remove]')) { cart.splice(idx, 1); }
    else if (e.target.closest('[data-inc]')) cart[idx].qty = Math.min(10, cart[idx].qty + 1);
    else if (e.target.closest('[data-dec]')) { cart[idx].qty -= 1; if (cart[idx].qty <= 0) cart.splice(idx, 1); }
    else return;
    save(cart); renderCart();
  });
  $('[data-cart-items]').addEventListener('change', e => { const row = e.target.closest('.item'); if (!row || e.target.type !== 'number') return; const idx = +row.dataset.idx; cart[idx].qty = Math.max(1, Math.min(10, +e.target.value || 1)); save(cart); renderCart(); });
  doc.addEventListener('keydown', e => { if (e.key === 'Escape') { setCart(false); setDrawer(false); setQuick(false); } });
  async function refreshCart(force) {
    await prelaunch.refresh(cart, force);
    const state = prelaunch.summary(cart);
    state.entries.forEach(entry => { if (entry.status !== 'checking' && cart[entry.index]) Object.assign(cart[entry.index], entry.item); });
    save(cart); renderCart();
  }
  $('[data-cart-checkout]').addEventListener('click', e => {
    const state = prelaunch.summary(cart);
    if (state.checking || !state.ready.length) { e.preventDefault(); renderCart(); if (state.checking) refreshCart(true); }
  });
  $('[data-cart-retry]').addEventListener('click', () => refreshCart(true));
  window.addEventListener('focus', () => { if (cartEl.getAttribute('aria-hidden') === 'false') refreshCart(true); });
  renderCart();
  if (cart.length) refreshCart(true);

  /* ---- which language? ----
     Asked once, on the first visit, and never again: the answer lives in this
     browser. Anyone who arrives already on a French page has answered it by
     arriving, so they are never interrupted. */
  (() => {
    const box = $('[data-langpick]'); if (!box) return;
    const KEY = 'dd_lang';
    const here = LANG === 'fr' || /^\/fr(\/|$)/.test(location.pathname) ? 'fr' : 'en';
    let saved = null; try { saved = localStorage.getItem(KEY); } catch (e) { }
    const remember = v => { try { localStorage.setItem(KEY, v); } catch (e) { } };
    $$('a[hreflang]').forEach(a => a.addEventListener('click', () => {
      const to = (a.getAttribute('hreflang') || '').slice(0, 2);
      if (to === 'en' || to === 'fr') remember(to);
    }));
    if (here === 'fr') { remember('fr'); return; }
    if (saved === 'fr' && box.dataset.fr) { location.replace(box.dataset.fr); return; }
    if (saved) return;
    const show = o => { box.hidden = !o; box.setAttribute('aria-hidden', o ? 'false' : 'true'); body.style.overflow = o ? 'hidden' : ''; };
    show(true);
    $('[data-lang-en]', box).addEventListener('click', () => { remember('en'); show(false); });
    $('[data-lang-fr]', box).addEventListener('click', () => {
      remember('fr');
      const to = box.dataset.fr;
      if (to) location.href = to; else show(false);
    });
    doc.addEventListener('keydown', e => { if (e.key === 'Escape' && !box.hidden) { remember('en'); show(false); } });
  })();

  /* ---- search: type a name or a word, sets appear; the top hit brings its neighbours ----
     On the store the theme flips DD_SHOPIFY_SEARCH on and Shopify's own
     predictive search answers (titles, tags, types, descriptions), with its
     recommendations as the "you might also like" row. On the static site the
     same box searches products.js locally: title + keywords (collections,
     colour, shapes, cat-eye, type, a slice of the description). */
  const srch = $('#search');
  if (srch) {
    const input = $('[data-search-input]', srch), list = $('[data-search-results]', srch), rel = $('[data-search-related]', srch), relList = rel && rel.querySelector('ul'), hint = $('[data-search-hint]', srch), all = $('[data-search-all]', srch), form = $('[data-search-form]', srch);
    const S = LANG === 'fr'
      ? { none: 'Rien ne correspond — essayez un seul mot, comme « rose ».', all: 'Voir tous les résultats', see: n => `Voir les ${n} résultats` }
      : { none: 'Nothing matches that — try one word, like “pink”.', all: 'See all results', see: n => `See all ${n} results` };
    const useShopify = !!window.DD_SHOPIFY_SEARCH;
    /* SHOP carries the /fr prefix on the French storefront. Without it the
       drawer searched the English catalogue and the submit handler below
       threw away the form's own French action. */
    const shopUrl = useShopify ? SHOP + '/search' : (form ? form.getAttribute('action') : ROOT + 'shop.html');
    const setOpen = o => { srch.setAttribute('aria-hidden', o ? 'false' : 'true'); body.style.overflow = o ? 'hidden' : ''; if (o) setTimeout(() => input.focus(), 60); };
    $$('[data-search-open]').forEach(b => b.addEventListener('click', () => setOpen(true)));
    $$('[data-search-close]', srch).forEach(b => b.addEventListener('click', () => setOpen(false)));
    doc.addEventListener('keydown', e => { if (e.key === 'Escape') setOpen(false); if (e.key === '/' && !/input|textarea|select/i.test(doc.activeElement.tagName)) { e.preventDefault(); setOpen(true); } });
    const norm = v => String(v || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    const title = p => typeof p.t === 'object' ? (p.t[LANG] || p.t.en) : (p.title || p.t);
    const href = p => p.url ? U(typeof p.url === 'object' ? p.url[LANG] : p.url) : '#';
    const pic = p => p.img ? U(p.img) : '';
    const card = p => `<li><a href="${href(p)}">${pic(p) ? `<img src="${pic(p)}" alt="" loading="lazy">` : '<span class="srch__ph"></span>'}<span class="srch__t"><strong>${esc(title(p))}</strong><small>${typeof p.price === 'number' ? fmt(p.price) : esc(p.price || '')}</small></span></a></li>`;
    const P = () => (window.DD_PRODUCTS || []).filter(p => p.img);
    const localHits = q => {
      const toks = norm(q).split(/\s+/).filter(Boolean); if (!toks.length) return [];
      return P().map(p => { const t = norm(title(p)), k = norm(p.k ? (p.k[LANG] || p.k.en) : ''); const ix = t + ' ' + k + ' ' + p.h.replace(/-/g, ' ');
        if (!toks.every(x => ix.includes(x))) return null; return { p, s: (toks.every(x => t.includes(x)) ? 2 : 0) + (t.startsWith(toks[0]) ? 1 : 0) }; })
        .filter(Boolean).sort((a, b) => b.s - a.s).map(x => x.p);
    };
    const localRelated = hits => { if (!hits.length) return []; const top = hits[0], cols = top.c || []; return P().filter(p => p.h !== top.h && !hits.includes(p) && (p.c || []).some(c => cols.includes(c))).slice(0, 4); };
    let timer, seq = 0;
    const render = (hits, related, q) => {
      hint.hidden = !!q; list.innerHTML = q && !hits.length ? `<li class="srch__none">${S.none}</li>` : hits.slice(0, 8).map(card).join('');
      rel.hidden = !related.length; if (relList) relList.innerHTML = related.map(card).join('');
      all.hidden = !q || !hits.length; all.textContent = hits.length > 8 ? S.see(hits.length) : S.all; all.href = shopUrl + '?q=' + encodeURIComponent(q);
    };
    const shopifyHits = async q => {
      const r = await fetch(`${SHOP}/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,tag`);
      const j = await r.json(); const prods = (j.resources && j.resources.results && j.resources.results.products) || [];
      const hits = prods.map(p => ({ h: p.handle, id: p.id, t: p.title, price: '$' + p.price, img: p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || ''), url: p.url }));
      let related = [];
      if (hits.length && hits[0].id) { try { const rr = await fetch(`${SHOP}/recommendations/products.json?product_id=${hits[0].id}&limit=4&intent=related`); const rj = await rr.json(); related = (rj.products || []).filter(p => !hits.some(h => h.h === p.handle)).map(p => ({ h: p.handle, t: p.title, price: '$' + (p.price / 100).toFixed(2), img: p.featured_image || '', url: p.url })); } catch (e) { } }
      return { hits, related };
    };
    input.addEventListener('input', () => {
      clearTimeout(timer); const q = input.value.trim();
      timer = setTimeout(async () => {
        const my = ++seq;
        if (!q) { render([], [], ''); return; }
        if (useShopify) { try { const { hits, related } = await shopifyHits(q); if (my === seq) render(hits, related, q); } catch (e) { const h = localHits(q); if (my === seq) render(h, localRelated(h), q); } }
        else { const h = localHits(q); render(h, localRelated(h), q); }
      }, 140);
    });
    if (form) form.addEventListener('submit', e => { const q = input.value.trim(); if (!q) { e.preventDefault(); return; } if (useShopify) { e.preventDefault(); location.href = SHOP + '/search?q=' + encodeURIComponent(q); } });
  }

  /* ---- quick add ---- */
  const quick = $('#quick'); let qp = null, qsel = [];
  function setQuick(open) { quick.setAttribute('aria-hidden', open ? 'false' : 'true'); if (!open) body.style.overflow = ''; const qpnl = $('.quick__panel'); setTimeout(() => { if (open) { qpnl.style.opacity = '1'; if (innerWidth > 900) qpnl.style.transform = 'translate(-50%,-50%)'; else qpnl.style.transform = 'none'; } else { qpnl.style.opacity = ''; qpnl.style.transform = ''; } }, 600); }
  function renderQuickOptions() {
    const box = $('[data-quick-options]');
    box.innerHTML = qp.options.map((o, i) => `<fieldset class="opt" data-pos="${i}"><legend>${esc({ size: T.size, shape: T.shape }[o.key] || o.key)}</legend><div class="chips chips--opt">${o.values.map(v => `<button type="button" class="chip${qsel[i] === v.key ? ' is-on' : ''}${DD.inStock(qp, qsel, i, v.key) ? '' : ' is-off'}" data-value="${esc(v.key)}">${o.key === 'shape' ? `<svg class="nail" viewBox="0 0 60 100"><use href="#shape-${v.key}"/></svg>` : ''}<span>${esc(DD.optionLabel(o, v.key))}</span></button>`).join('')}</div></fieldset>`).join('');
    const v = DD.findVariant(qp, qsel); $('[data-quick-price]').textContent = v ? fmt(v.price) : fmt(qp.price);
    const qm = $('[data-quick-mto]'); if (qm) qm.hidden = !(v && v.mto);
    $('[data-quick-add]').disabled = !(v && v.available);
  }
  DD.openQuick = (handle) => {
    /* The quick-add catalogue is a snapshot baked at build time, and the
       store carries more products than it. A handle it has never heard of
       used to return here silently, so the button did nothing at all.
       Send the shopper to the product page instead of swallowing the tap. */
    const P = window.DD_PRODUCTS;
    qp = P && P.find(p => p.h === handle);
    if (!qp) { location.href = SHOP + '/products/' + handle; return; }
    if (!qp.options.length) { const line = DD.lineFor(qp, [], 1); if (line) DD.add(line); return; }
    qsel = []; qp.options.forEach((o, i) => { qsel[i] = (o.values.find(v => DD.available(qp, qsel, i, v.key)) || o.values[0]).key; });
    $('[data-quick-title]').textContent = qp.t[LANG];
    const img = $('[data-quick-img]'); img.src = qp.img ? U(qp.img) : ''; img.alt = qp.t[LANG]; img.parentElement.style.display = qp.img ? '' : 'none';
    $('[data-quick-link]').href = U(qp.url[LANG]);
    renderQuickOptions(); setQuick(true); body.style.overflow = 'hidden';
  };
  $('[data-quick-options]').addEventListener('click', e => { const c = e.target.closest('.chip'); if (!c) return; const pos = +c.closest('.opt').dataset.pos; qsel[pos] = c.dataset.value; renderQuickOptions(); });
  $('[data-quick-add]').addEventListener('click', () => { const line = DD.lineFor(qp, qsel, 1); if (!line) return; setQuick(false); DD.add(line); });
  $$('[data-quick-close]').forEach(b => b.addEventListener('click', () => setQuick(false)));
  doc.addEventListener('click', e => { const b = e.target.closest('[data-quick]'); if (b) { e.preventDefault(); if (b.dataset.comingSoon) { location.href = SHOP + '/products/' + b.dataset.quick; return; } DD.openQuick(b.dataset.quick); } });

  /* ---- forms: newsletter / contact post to the Shopify store; show a message and let the browser follow ---- */
  /* Shopify answers a contact-form post by sending the shopper back to the
     page they came from with ?contact_posted=true, and nothing was reading it:
     they submitted, the page reloaded, and there was no sign it had worked.
     Say so, on the form they actually used, and tidy the URL after. */
  if (/[?&]contact_posted=true/.test(location.search)) {
    const posted = $('[data-form-msg]');
    if (posted) {
      posted.hidden = false;
      posted.className = 'form__msg form__msg--ok';
      posted.textContent = LANG === 'fr'
        ? 'Merci! Nous avons bien reçu votre message et nous vous répondons sous peu.'
        : 'Thank you! We have your message and we will come back to you shortly.';
      posted.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    try { history.replaceState(null, '', location.pathname + location.hash); } catch (e) { }
  }

  $$('form[data-form]').forEach(f => f.addEventListener('submit', e => {
    const email = f.querySelector('input[type=email]');
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) { e.preventDefault(); email.focus(); email.setCustomValidity(' '); email.reportValidity(); setTimeout(() => email.setCustomValidity(''), 1500); return; }
    const btn = f.querySelector('button[type=submit]'); if (btn) { btn.disabled = true; btn.textContent = LANG === 'fr' ? 'Envoi…' : 'Sending…'; }
    const msg = f.querySelector('[data-form-msg]'); if (msg) { msg.hidden = false; msg.textContent = LANG === 'fr' ? 'Merci! Redirection vers notre boutique pour confirmer…' : 'Thank you! Redirecting to our store to confirm…'; }
  }));

  /* ---- share ---- */
  $$('[data-share]').forEach(b => b.addEventListener('click', async () => {
    const data = { title: doc.title, url: location.href };
    if (navigator.share) { try { await navigator.share(data); } catch (e) { } }
    else { try { await navigator.clipboard.writeText(location.href); DD.toast(T.copied); } catch (e) { } }
  }));

  /* ---- lite YouTube ---- */
  $$('.yt[data-yt]').forEach(y => {
    const id = y.dataset.yt, btn = $('.yt__btn', y);
    btn && btn.addEventListener('click', () => { const f = doc.createElement('iframe'); f.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&mute=1`; f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'; f.allowFullscreen = true; f.title = y.dataset.title || 'Video'; y.appendChild(f); btn.remove(); });
  });

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* ---- paint dab on click (pairs with the paintbrush cursor) ---- */
  let dabN = 0;
  doc.addEventListener('pointerdown', e => { if (reduce || e.button > 0) return; const d = doc.createElement('span'); d.className = 'dab' + (++dabN % 3 === 0 ? ' dab--gold' : ''); d.style.left = e.clientX + 'px'; d.style.top = e.clientY + 'px'; body.appendChild(d); setTimeout(() => d.remove(), 700); }, { passive: true });

  /* ---- videos: play when visible, pause off-screen; respect reduced motion ---- */
  $$('video[data-auto]').forEach(v => {
    if (reduce) { v.removeAttribute('autoplay'); return; }
    const io = new IntersectionObserver(es => es.forEach(e => { const near = !window.innerHeight && e.boundingClientRect.top < 2400 && e.boundingClientRect.bottom > -400; if (e.isIntersecting || near) { const p = v.play(); if (p && p.catch) p.catch(() => { }); } else v.pause(); }), { threshold: 0.2 });
    io.observe(v);
  });
})();

/* ---------- the sky ----------
   One living sky behind every page, pink and blue.
   One continuous cloudscape behind the whole page: a small canvas (about 180px
   wide) upscaled to the viewport, so every soft blob reads as a cloud. Two
   layers of blobs drift, breathe (radius on a slow sine), fade out and are
   born again somewhere else — the clouds never repeat. Cheap enough for a
   phone; a single frame under prefers-reduced-motion. */
(() => {
  let c = document.querySelector('[data-sky]');
  if (!c) { c = document.createElement('canvas'); c.className = 'sky'; c.setAttribute('data-sky', ''); c.setAttribute('aria-hidden', 'true'); document.body.prepend(c); }
  /* the photograph: a sea of pink and blue clouds, under the living layer.
     It pans slowly on its own, slides with the scroll and leans with the mouse. */
  const ROOT = document.body.dataset.root || '';
  const img = document.createElement('div'); img.className = 'skyimg'; img.setAttribute('aria-hidden', 'true');
  /* Three sizes, because this one image is the whole page's background and it is
     stretched edge to edge. A phone gets the small one, an ordinary screen the
     1920, and a Retina or 4K screen the 4096 — on those the 1920 was being
     doubled and came out soft. Nobody downloads a size their screen cannot show. */
  const sky = innerWidth < 900 ? '-sm'
    : (devicePixelRatio > 1.3 || innerWidth >= 2000) ? '-4k'
    : '';
  img.style.backgroundImage = `url("${window.DD_ASSET_BASE}tex-sky-night${sky}.jpg")`;
  document.body.prepend(img);
  const stars = document.createElement('div'); stars.className = 'stars'; stars.setAttribute('aria-hidden', 'true');
  document.body.prepend(stars);
  const ctx = c.getContext('2d', { alpha: false });
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const PALETTE = ['#EEB8B2', '#E2B7AF', '#D6A3A0', '#C98F92', '#AE6E79', '#8E6B7C', '#6E5A72', '#8E9CBA', '#4A4159', '#2A2436'];
  const rnd = (a, b) => a + Math.random() * (b - a);
  let W = 180, Hh = 110, blobs = [];
  const born = (fresh) => {
    const back = Math.random() < .45;
    const b = {
      back, x: rnd(-30, W + 30), y: rnd(-10, Hh + 10),
      r0: back ? rnd(44, 80) : rnd(18, 46), vx: (back ? rnd(1.6, 3.2) : rnd(3.2, 6.5)) * (Math.random() < .85 ? 1 : -1), vy: rnd(-.6, .6),
      breathe: rnd(.2, .42), freq: rnd(.18, .4), phase: rnd(0, 6.28),
      color: PALETTE[Math.floor(Math.random() * PALETTE.length)], alpha: back ? rnd(.35, .6) : rnd(.5, .8),
      life: fresh ? rnd(0, 20) : 0, span: rnd(16, 34)
    };
    return b;
  };
  const size = () => {
    const vw = innerWidth, vh = innerHeight;
    W = 180; Hh = Math.max(60, Math.round(180 * vh / vw * 1.9));   // almost two screens tall: room to slide with the scroll
    c.width = W; c.height = Hh;
    if (!blobs.length) blobs = Array.from({ length: 26 }, () => born(true));
  };
  const hex = h => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
  /* the mouse moves the sky: the whole cloudscape leans gently away from the
     pointer (the far layer less, the near layer more) and clouds under the
     cursor drift aside, so moving the mouse feels like stirring the sky. */
  let mx = 0, my = 0, ox = 0, oy = 0, px = -1, py = -1;
  addEventListener('pointermove', e => { mx = e.clientX / innerWidth * 2 - 1; my = e.clientY / innerHeight * 2 - 1; px = e.clientX / innerWidth * W; py = e.clientY / innerHeight * (Hh / 1.9); }, { passive: true });
  addEventListener('pointerleave', () => { px = py = -1; });
  let last = performance.now(), t = 0;
  const draw = (now) => {
    const dt = Math.min(.05, (now - last) / 1000); last = now; t += dt;
    // base sky: pink light at the top, peach through the middle, a cooler lavender at the bottom
    const g = ctx.createLinearGradient(0, 0, 0, Hh);
    g.addColorStop(0, '#0B0F18'); g.addColorStop(.36, '#1A1726'); g.addColorStop(.68, '#4A3A4C'); g.addColorStop(1, '#8A6068');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, Hh);
    // a slow moving warm light
    const lx = W * (.5 + .35 * Math.sin(t * .11)), ly = Hh * (.35 + .2 * Math.cos(t * .09));
    const lg = ctx.createRadialGradient(lx, ly, 0, lx, ly, W * .6);
    lg.addColorStop(0, 'rgba(226,183,175,.30)'); lg.addColorStop(1, 'rgba(226,183,175,0)');
    ctx.fillStyle = lg; ctx.fillRect(0, 0, W, Hh);
    ox += (mx - ox) * Math.min(1, dt * 2); oy += (my - oy) * Math.min(1, dt * 2);
    img.style.transform = `translate3d(${(-ox * 2.2 + Math.sin(t * .045) * 4.2 + Math.sin(t * .017) * 1.8).toFixed(2)}%, ${(-oy * 1.4 - Math.min(scrollY * .06, innerHeight * .08) / innerHeight * 100 + Math.cos(t * .031) * 2.4).toFixed(2)}%, 0) scale(1.14)`;
    for (const pass of [true, false]) for (const b of blobs) {
      if (b.back !== pass) continue;
      b.x += b.vx * dt * (1 + .35 * Math.sin(t * .15)); b.y += b.vy * dt; b.life += dt;
      if (px >= 0) { const dx = b.x - px, dy = b.y - py, d = Math.hypot(dx, dy) || 1, R = b.back ? 40 : 60; if (d < R) { const f = (1 - d / R) * (b.back ? 6 : 14) * dt; b.x += dx / d * f; b.y += dy / d * f; } }
      const r = b.r0 * (1 + b.breathe * Math.sin(t * b.freq + b.phase));
      const u = b.life / b.span, fade = u < .15 ? u / .15 : u > .85 ? (1 - u) / .15 : 1;
      if (u >= 1) { Object.assign(b, born(false)); continue; }
      if (b.x - r > W + 40) b.x = -r - 20; else if (b.x + r < -40) b.x = W + r + 20;
      const [R, G, B] = hex(b.color);
      const sx = b.x - ox * W * (b.back ? .025 : .06), sy = b.y - oy * Hh * (b.back ? .015 : .035);
      const rg = ctx.createRadialGradient(sx, sy, 0, sx, sy, r);
      rg.addColorStop(0, `rgba(${R},${G},${B},${(b.alpha * fade).toFixed(3)})`);
      rg.addColorStop(.55, `rgba(${R},${G},${B},${(b.alpha * fade * .85).toFixed(3)})`);
      rg.addColorStop(.8, `rgba(${R},${G},${B},${(b.alpha * fade * .35).toFixed(3)})`);
      rg.addColorStop(1, `rgba(${R},${G},${B},0)`);
      ctx.fillStyle = rg; ctx.fillRect(sx - r, sy - r, r * 2, r * 2);
    }
  };
  let raf = 0;
  const loop = (now) => { draw(now); raf = requestAnimationFrame(loop); };
  size(); addEventListener('resize', size);
  /* the sky slides against the scroll, like the cloud sections elsewhere */
  let sTick = false;
  const slide = () => { sTick = false; c.style.transform = `translate3d(0, ${(-Math.min(scrollY * 0.5, innerHeight * 0.85)).toFixed(1)}px, 0) scale(1.04)`; };
  if (!reduce) addEventListener('scroll', () => { if (!sTick) { sTick = true; requestAnimationFrame(slide); } }, { passive: true });
  if (reduce) { draw(performance.now()); return; }
  raf = requestAnimationFrame(loop);
  document.addEventListener('visibilitychange', () => { if (document.hidden) cancelAnimationFrame(raf); else { last = performance.now(); raf = requestAnimationFrame(loop); } });
})();



